import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Layout, Typography, Spin, Breadcrumb, Tooltip } from "antd";
import MenuLeft from "../components/hooks_components/MenuLeft";
import PFheader from "../components/hooks_components/Header";
import { camelCase, compact, get, replace, split } from "lodash";
import { useTranslation } from "react-i18next";
import { ENVIRONMENT } from "../utils/properties";
import { ArrowLeftOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

const { Title, Link } = Typography;
const { Header, Footer, Content } = Layout;

const BasicLayout = ({
  haveBreadcrumb = false,
  isCustom = false,
  haveTitle = false,
  haveBack = false,
  backUrl = "",
  name = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const pageIsLoading = useSelector((state) => get(state.loadingDuck, "pageIsLoading", false));
  const section = useSelector((state) => get(state.sectionDuck, "section", { title: "" }));
  const splittedPath = compact(split(location.pathname, "/"));
  const goBack = (link) => () => {
    navigate(link);
  };
  const [state, setState] = useState({
    changeVisibility: window.innerWidth < 768,
  });

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => {
      window.removeEventListener("resize", updateMedia);
    };
  }, []);

  const updateMedia = () => {
    setState({
      ...state,
      changeVisibility: window.innerWidth < 768,
    });
  };

  const getSplittedPathTitle = (p, k, length) => {
    if (length === k + 1) {
      return isCustom ? t(section.title) : t(`menuLeft.${camelCase(replace(p, "/", ""))}`);
    } else {
      return (
        <span className="cursor-pointer" onClick={goBack(`/${p}`)}>
          {t(`menuLeft.${camelCase(replace(p, "/", ""))}`)}
        </span>
      );
    }
  };

  return (
    <Layout className="min-h-100vh">
      <Header className="PFheader">
        <PFheader />
      </Header>
      <Layout>
        <MenuLeft change={state.changeVisibility} />
        <div
          onClick={() => setState((prevState) => ({ ...prevState, changeVisibility: !state.changeVisibility }))}
          className="menu-left-overlay"
        />
        <Layout className="h-100">
          <div
            className="icon-menu"
            onClick={() => setState((prevState) => ({ ...prevState, changeVisibility: !state.changeVisibility }))}
          >
            {state.changeVisibility === true ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </div>
          <Breadcrumb
            hidden={!haveBreadcrumb}
            className="PFbreadcrumb"
            separator=">"
            items={[
              {
                title: (
                  <a href={ENVIRONMENT.BASE_URL} className="cursor-pointer">
                    Home
                  </a>
                ),
                key: "home",
              },
              ...splittedPath.map((p, k) => ({
                title: getSplittedPathTitle(p, k, splittedPath.length),
                key: `${p}-${k}`, // Chiave unica
              })),
            ]}
          />

          <div className="PFtitle" hidden={!haveTitle}>
            <div className="parallelogram">
              <Title key="title" level={5}>
                {haveBack ? (
                  <>
                    <Link className="PFwhite" onClick={goBack(backUrl)}>
                      <ArrowLeftOutlined />
                    </Link>{" "}
                    |{" "}
                  </>
                ) : (
                  ""
                )}
                {isCustom && t(section.title).length > 20 ? (
                  <Tooltip title={t(section.title)} key={t(section.title)}>
                    {t(section.title)}
                  </Tooltip>
                ) : (
                  <>{!isCustom ? t(name) : t(section.title)}</>
                )}
              </Title>
            </div>
          </div>
          <Content>
            <div className="PFcontent p-relative">
              <Outlet />
              {pageIsLoading ? (
                <div className="container-spinner-positioning">
                  <Spin spinning={pageIsLoading} className="spinner-positioning" />
                </div>
              ) : (
                ""
              )}
            </div>
          </Content>
        </Layout>
      </Layout>
      <Footer className="PFfooter" />
    </Layout>
  );
};

export default BasicLayout;
